import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import useStyles from './styles';
import { useStore } from 'src/stores';
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SelectMenu, BackdropLoader } from '@livable/saas-react-components';
import { LinearProgress, MenuItem, Typography } from '@mui/material';
export const AssociatedVendor = observer(_ref => {
  var _store$vendors$getVen;
  let isModal = _ref.isModal,
    _ref$utilityProviderN = _ref.utilityProviderName,
    utilityProviderName = _ref$utilityProviderN === void 0 ? false : _ref$utilityProviderN,
    _ref$utilityProviderI = _ref.utilityProviderId,
    utilityProviderId = _ref$utilityProviderI === void 0 ? false : _ref$utilityProviderI;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const vendorExternalId = (_store$vendors$getVen = store.vendors.getVendorByUtilityProviderId(utilityProviderId)) === null || _store$vendors$getVen === void 0 ? void 0 : _store$vendors$getVen.externalId;
  if (utilityProviderId && vendorExternalId && !store.vendors.tempData.vendorExternalId) {
    store.vendors.changeTempDataVendor(vendorExternalId);
  }
  if (utilityProviderId && !store.vendors.tempData.utilityProviderLivableId) store.vendors.changeTempDataProperty(utilityProviderId);
  const _useState = useState(store.vendors.tempData.vendorExternalId ? store.vendors.tempData.vendorExternalId : null),
    _useState2 = _slicedToArray(_useState, 2),
    vendorValue = _useState2[0],
    setVendorValue = _useState2[1];
  useEffect(() => {
    if (vendorExternalId && !vendorValue) {
      setVendorValue(vendorExternalId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorExternalId]);
  const _useState3 = useState(utilityProviderId ? utilityProviderId : null),
    _useState4 = _slicedToArray(_useState3, 2),
    providerValue = _useState4[0],
    setProviderValue = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    searchUtilityProvidersResultItems = _useState6[0],
    setSearchUtilityProvidersResultItems = _useState6[1];
  // const [searchVendorsResultItems, setSearchVendorsResultItems] = useState(
  //   store.vendors.vendors.length > 0
  //     ? toJS(store.vendors.vendors).map(i => {
  //         return { ...i, label: i.companyName, id: i.externalId, key: i.externalId };
  //       })
  //     : []
  // );
  const _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    searchVendorsResultItems = _useState8[0],
    setSearchVendorsResultItems = _useState8[1];
  let searchUtilityProvidersHandler;
  const searchUtilityProviders = async value => {
    if (value && value.length > 0) {
      if (searchUtilityProvidersHandler) {
        clearTimeout(searchUtilityProvidersHandler);
      }
      searchUtilityProvidersHandler = setTimeout(() => store.utilityProviders.searchUtilityProvidersPlainAsync.run(value).then(resp => {
        setSearchUtilityProvidersResultItems(resp.response.map(item => {
          return _objectSpread(_objectSpread({}, item), {}, {
            label: item.value,
            id: item.key,
            key: item.key
          });
        }));
      }), 350);
    } else {
      if (searchUtilityProvidersHandler) clearTimeout(searchUtilityProvidersHandler);
    }
    setSearchUtilityProvidersResultItems([]);
  };
  let searchVendorsHandler;
  const searchVendors = async value => {
    if (value && value.length > 1) {
      if (searchVendorsHandler) {
        clearTimeout(searchVendorsHandler);
      }
      searchVendorsHandler = setTimeout(() => store.vendors.getVendorsAsync.run({
        page: 0,
        pageSize: 20,
        searchPhrase: value
      }).then(resp => {
        var _resp$response;
        setSearchVendorsResultItems(resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.items.map(item => {
          return _objectSpread(_objectSpread({}, item), {}, {
            label: item.companyName,
            id: item.externalId,
            key: item.externalId
          });
        }));
      }), 350);
    } else {
      if (searchVendorsHandler) clearTimeout(searchVendorsHandler);
    }
    setSearchVendorsResultItems([]);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.vendors.getVendorsAsync.inProgress || store.vendors.associateVendorsAsync.inProgress || store.vendors.getVendorsByUtilityProviderIdAsync.inProgress
  }), !isModal && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.select_provider')), /*#__PURE__*/React.createElement("div", {
    className: classes.associatedVendor
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.associatedVendorData
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Provider",
    enableSearch: true,
    value: providerValue,
    onSearch: searchUtilityProviders,
    id: "provider-appfolio-selector",
    labelId: "provider-appfolio-selector-label",
    searchPlaceholder: 'Search provider',
    onChange: e => {
      setProviderValue(e.target.value);
      store.vendors.changeTempDataProperty(e.target.value);
    },
    renderValue: selected => {
      var _searchUtilityProvide;
      if ((selected === null || selected === void 0 ? void 0 : selected.length) === 0) return '';
      if (selected === utilityProviderId) return utilityProviderName;
      return (_searchUtilityProvide = searchUtilityProvidersResultItems.find(item => item.id === selected)) === null || _searchUtilityProvide === void 0 ? void 0 : _searchUtilityProvide.label;
    }
  }, store.utilityProviders.searchUtilityProvidersPlainAsync.inProgress && /*#__PURE__*/React.createElement(MenuItem, {
    value: 'loader',
    className: classes.associatedVendorItem
  }, /*#__PURE__*/React.createElement(LinearProgress, null)), searchUtilityProvidersResultItems.length === 0 && !store.utilityProviders.searchUtilityProvidersPlainAsync.inProgress && /*#__PURE__*/React.createElement(MenuItem, {
    value: 'none',
    disabled: true,
    className: classes.associatedVendorItem
  }, "Start searching provider"), searchUtilityProvidersResultItems.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.id,
    className: classes.associatedVendorItem
  }, /*#__PURE__*/React.createElement("span", null, i.label)))))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.link_associated_vendor_in_appfolio'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xssSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.select_the_corresponding_vendor'))), /*#__PURE__*/React.createElement("div", {
    className: classes.associatedVendor
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.associatedVendorData
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    value: vendorValue,
    enableSearch: true,
    displayEmpty: !!vendorValue,
    onSearch: searchVendors,
    label: "Associated Vendor in AppFolio",
    id: "associated-vendor-in-appfolio-selector",
    labelId: "associated-vendor-in-appfolio-selector-label",
    searchPlaceholder: 'Search Associated Vendor',
    onChange: e => {
      setVendorValue(e.target.value);
      store.vendors.changeTempDataVendor(e.target.value);
    },
    renderValue: selected => {
      var _searchVendorsResultI;
      if ((selected === null || selected === void 0 ? void 0 : selected.length) === 0) return '';
      if (selected === store.vendors.tempData.vendorExternalId) {
        var _store$vendors$vendor;
        return (_store$vendors$vendor = store.vendors.vendors.find(i => i.externalId === store.vendors.tempData.vendorExternalId)) === null || _store$vendors$vendor === void 0 ? void 0 : _store$vendors$vendor.companyName;
      }
      return searchVendorsResultItems === null || searchVendorsResultItems === void 0 || (_searchVendorsResultI = searchVendorsResultItems.find(item => item.id === selected)) === null || _searchVendorsResultI === void 0 ? void 0 : _searchVendorsResultI.label;
    }
  }, store.vendors.getVendorsAsync.inProgress && /*#__PURE__*/React.createElement(MenuItem, {
    value: 'loader',
    className: classes.associatedVendorItem
  }, /*#__PURE__*/React.createElement(LinearProgress, null)), (searchVendorsResultItems === null || searchVendorsResultItems === void 0 ? void 0 : searchVendorsResultItems.length) === 0 && !store.vendors.getVendorsAsync.inProgress && /*#__PURE__*/React.createElement(MenuItem, {
    value: 'none',
    disabled: true,
    className: classes.associatedVendorItem
  }, "Start searching vendor"), searchVendorsResultItems === null || searchVendorsResultItems === void 0 ? void 0 : searchVendorsResultItems.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    value: i.id,
    className: classes.associatedVendorItem
  }, /*#__PURE__*/React.createElement("span", null, i.label), /*#__PURE__*/React.createElement("i", null, "Address:", ' ', !i.line1 && !i.city && !i.state && !i.zip && !i.line2 ? 'N/A' : "".concat(i.line1, " ").concat(i.city, ", ").concat(i.state, " ").concat(i.zip).concat(i !== null && i !== void 0 && i.line2 ? ', ' + i.line2 : ''))))))), /*#__PURE__*/React.createElement("br", null));
});